import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useTable } from '../../../hooks/use-table';

const className = 'cross-analysis-1';
const attrs = `border='1' bordercolor='#C0BEC7'`;

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-cross-analysis-1',
  props: {
    tableHeaderList: {},
    tableDataList: {}
  },
  setup(__props: any) {

const props = __props;

const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { innerHTML: _unref(html) }, null, 8, _hoisted_1))
}
}

})